import { Component, ChangeDetectionStrategy, InputSignal, input } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ExpandablePanelComponent, ViewMoreComponent } from '@tdwb/core';

@Component({
  selector: 'td-wb-fpl-faq',
  templateUrl: './fpl-faq.component.html',
  styleUrls: ['./fpl-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    TranslatePipe,
    ExpandablePanelComponent,
    ViewMoreComponent
  ]
})
export class FplFaqComponent {
  displayAll: InputSignal <boolean> = input<boolean>(true);
  protected showViewLess: boolean = false;

  protected toggleViewMore(): void {
    this.showViewLess = !this.showViewLess;
  }
}
